import * as React from 'react';
import { PageSection, Title, Button, EmptyState, EmptyStateBody, EmptyStateFooter } from '@patternfly/react-core';
import { useNavigate } from 'react-router-dom';
import { LockIcon } from '@patternfly/react-icons';

const Unauthorized: React.FunctionComponent = () => {
  const navigate = useNavigate();

  return (
    <PageSection hasBodyWrapper={false}>
      <EmptyState titleText="Access Denied" variant="full" icon={LockIcon}>
        <EmptyStateBody>
          You do not have permission to access this page. Please contact your administrator if you believe this is an error.
        </EmptyStateBody>
        <EmptyStateFooter>
          <Button onClick={() => navigate('/', { replace: true })}>Return to Home</Button>
        </EmptyStateFooter>
      </EmptyState>
    </PageSection>
  );
};

export { Unauthorized }; 